import React from "react";

export default function TimeAndDayIcon(props) {
  return (
    <svg
      width="80px"
      height="80px"
      viewBox="0 0 80 80"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path
          d="M29,-5.68434189e-14 C13.0585753,-5.68434189e-14 0.0893387097,12.9971875 0.0893387097,28.9728125 C0.0893387097,48.7990625 25.9615484,77.9051562 27.0630806,79.1345312 C28.0977258,80.289375 29.9041452,80.2873437 30.9369194,79.1345312 C32.0384516,77.9051562 57.9106613,48.7990625 57.9106613,28.9728125 C57.9103495,12.9971875 44.9412688,-5.68434189e-14 29,-5.68434189e-14 Z"
          id="time-day-iconpath-1"
        ></path>
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="time-day-icon-Group-15"
          transform="translate(11.000000, 0.000000)"
        >
          <g id="time-day-icon-pin-copy">
            <g id="time-day-icon-Group-15-Copy">
              <mask id="time-day-icon-mask-2" fill="white">
                <use href="#time-day-iconpath-1"></use>
              </mask>
              <use
                id="time-day-icon-Shape"
                fill="#3721D2"
                fillRule="nonzero"
                href="#time-day-iconpath-1"
              ></use>
              <rect
                id="time-day-iconRectangle"
                fillOpacity="0.4"
                fill="#000000"
                fillRule="nonzero"
                mask="url(#time-day-icon-mask-2)"
                x="29"
                y="0"
                width="29"
                height="80"
              ></rect>
            </g>
          </g>
          <g id="sun-copy" transform="translate(5.000000, 7.000000)">
            <path
              d="M11.5346765,11.765625 C11.851494,12.06875 12.3546978,12.0644531 12.6659985,11.7558594 C12.9772992,11.4472656 12.9816338,10.9484375 12.6758498,10.634375 L7.83374452,5.834375 C7.51692708,5.53125 7.0137233,5.5355469 6.70242254,5.8441406 C6.39112187,6.1527344 6.38678728,6.6515625 6.69257127,6.965625 L11.5346765,11.765625 Z"
              id="time-day-icon-Path"
              fill="#FABE2C"
            ></path>
            <path
              d="M7.26315789,24.8 C7.70883021,24.8 8.07017544,24.4417969 8.07017544,24 C8.07017544,23.5582031 7.70883021,23.2 7.26315789,23.2 L0.807017544,23.2 C0.361345232,23.2 0,23.5582031 0,24 C0,24.4417969 0.361345232,24.8 0.807017544,24.8 L7.26315789,24.8 Z"
              id="time-day-icon-Path"
              fill="#FABE2C"
            ></path>
            <path
              d="M11.5346765,36.234375 L6.69257127,41.034375 C6.48293586,41.2351562 6.39860888,41.5328125 6.47269046,41.8125 C6.54637813,42.0921875 6.76665296,42.3105469 7.04879386,42.3835938 C7.33093476,42.4570312 7.63120208,42.3734375 7.83374452,42.165625 L12.6758498,37.365625 C12.9816338,37.0515625 12.9772992,36.5527344 12.6659985,36.2441406 C12.3546978,35.9355469 11.851494,35.93125 11.5346765,36.234375 Z"
              id="time-day-icon-Path"
              fill="#FABE2C"
            ></path>
            <path
              d="M23.4035088,37.4976562 L23.4035088,10.5023438 C16.5005139,11.3097656 11.2994278,17.1097656 11.2994278,24 C11.2994278,30.8902344 16.5005139,36.6902344 23.4035088,37.4976562 Z"
              id="time-day-icon-Path"
              fill="#FABE2C"
            ></path>
            <path
              d="M43.5789474,30.659375 C42.3656627,31.0734375 41.0885417,31.275 39.8055099,31.2550781 C33.6165365,31.1847656 28.6526692,26.1621094 28.7090186,20.0273438 C28.750394,16.1855469 30.6950384,12.6097656 33.9101049,10.4640625 C33.2500685,10.4121094 32.5856977,10.4 31.9634903,10.4 C29.506973,10.4007812 27.1001062,11.0863281 25.0175439,12.3777344 L25.0175439,35.6222656 C28.1096663,37.5398438 31.8673417,38.0949219 35.3889803,37.1539062 C38.9106188,36.2125 41.8778269,33.8605469 43.5789474,30.6625 L43.5789474,30.659375 Z"
              id="time-day-icon-Path"
              fill="#FFFFFF"
            ></path>
            <path
              d="M45.9393161,17.8222656 L44.1463816,17.5503906 C43.8803968,17.5101562 43.6522409,17.3414062 43.537966,17.1 L42.7719298,15.4832031 L42.0058936,17.1 C41.8916187,17.3414062 41.6634629,17.5101562 41.3974781,17.5503906 L39.6045435,17.8222656 L40.9285567,19.1679688 C41.1074561,19.3496094 41.1886308,19.6046875 41.1472553,19.8550781 L40.8430475,21.703125 L42.3822129,20.8601562 C42.6249486,20.7273438 42.918911,20.7273438 43.1616468,20.8601562 L44.7008121,21.703125 L44.3966043,19.8550781 C44.3552288,19.6046875 44.4364035,19.3496094 44.615303,19.1679688 L45.9393161,17.8222656 Z"
              id="time-day-icon-Path"
              fill="#FFFFFF"
            ></path>
            <path
              d="M23.2105263,48 C23.6561986,48 24.0175439,47.6417969 24.0175439,47.2 L24.0175439,39.2 C23.4784814,39.1992188 22.9398129,39.1707031 22.4035088,39.1144531 L22.4035088,47.2 C22.4035088,47.6417969 22.764854,48 23.2105263,48 Z"
              id="time-day-icon-Path"
              fill="#FABE2C"
            ></path>
            <path
              d="M24.0175439,0.8 C24.0175439,0.3582031 23.6561986,0 23.2105263,0 C22.764854,0 22.4035088,0.3582031 22.4035088,0.8 L22.4035088,8.8855469 C22.9398129,8.8292969 23.4784814,8.8007812 24.0175439,8.8 L24.0175439,0.8 Z"
              id="time-day-icon-Path"
              fill="#FABE2C"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
